//eslint-disable-next-line
import * as styles from 'style/_vars.module.scss';

const { red100, yellow100, green100, blue100, lgreen100 } = styles;
export const SLIDER_COLOR_RED100 = red100;
export const SLIDER_COLOR_YELLOW100 = yellow100;
export const SLIDER_COLOR_GREEN100 = green100;
export const SLIDER_COLOR_LGREEN100 = lgreen100;
export const SLIDER_COLOR_BLUE100 = blue100;
